import { SONNET_AUTH_ORIGIN } from '../../config';
import { SAVE_ERRORS } from './ErrorTypes';

export default function ErrorService(error) {
  if (error.state === 'authentication') {
    redirectSonnetLogin();
    return { isError: false };
  }

  if (error && error.error) {
    switch (error.code) {
      case 401:
        redirectSonnetLogin();
        return { isError: false };

      case 400:
      case 403:
      case 404:
        // error pop-up
        return { isError: true, save: SAVE_ERRORS.includes(error.type), type: error.type, state: error.state };

      case 500:
        // error pop-up
        return { isError: true, save: SAVE_ERRORS.includes(error.type), type: error.type, state: error.state };

      case 501:
        // error pop-up without save - error connecting to bff
        return { isError: true, save: false, type: error.type, state: error.state };

      default:
        return { isError: true, save: false, type: error.type, state: error.state };
    }
  }

  return { isError: false };
}

function redirectSonnetLogin() {
  window.sessionStorage.clear();
  window.localStorage.clear();
  window.location.replace(`${SONNET_AUTH_ORIGIN}/login`);
}

export function getErrorCode(error) {
  if (typeof error === 'object' && error.length) {
    return error[0].statusCode;
  }
  if (error.response?.status) {
    return error.response.status;
  }
  return 501;
}

export function getErrorMessage(error) {
  if (typeof error === 'object' && error.length) {
    return error[0].message;
  }
  if (error.response?.message) {
    return error.response.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'Network error';
}
